import { productApiClient } from '@/clients/ProductAPIClient';
import { ICmsAlbum } from '@/data/models/cms';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export default function useGetCmsAlbumsQuery(
  ids: Array<string | number>
): UseQueryResult<ICmsAlbum[], Error> {
  async function queryFn() {
    if (!ids?.length) return [];
    const response = await productApiClient.getCmsAlbums(ids);
    return response.data;
  }

  return useQuery({
    queryFn,
    queryKey: ['cms-albums', ids.sort()],
    staleTime: 10000,
  });
}
